import { Button } from '@advanza/ui'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import BaseModal, {
    BaseModalFooter,
    BaseModalHeader,
    BaseModalMainContent,
} from '@trustoo/components/modal/BaseModal'

interface DeleteDiscountModalProps {
    onConfirm: () => void
    onCancel: () => void
}

const DeleteDiscountModal = NiceModal.create(
    ({ onConfirm, onCancel }: DeleteDiscountModalProps) => {
        const modal = useModal()

        const onClose = () => {
            modal.resolve()
            modal.hide()
            onCancel()
        }

        return (
            <BaseModal onClose={onClose}>
                <BaseModalHeader>
                    <h2 className="text-display-xs font-bold">Delete Discount</h2>
                </BaseModalHeader>
                <BaseModalMainContent>
                    <p>
                        Are you sure you want to delete this discount? This action cannot be undone.
                    </p>
                </BaseModalMainContent>
                <BaseModalFooter>
                    <div className="row justify-end gap-2">
                        <Button appearance="outlined_primary" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            appearance="primary"
                            onClick={() => {
                                onConfirm()
                                modal.resolve()
                                modal.hide()
                            }}>
                            Delete
                        </Button>
                    </div>
                </BaseModalFooter>
            </BaseModal>
        )
    },
)

export default DeleteDiscountModal
